// Firebase project config (yesterday-stories-preprod).
// Values are sourced from REACT_APP_FIREBASE_* env vars (.env, gitignored;
// names documented in .env.template). Web API keys are not secret in the
// traditional sense — access is governed by Firebase Security Rules and
// Authorized Domains — but keeping them out of source is better practice.
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export default firebaseConfig;
